import { ENDPOINTS } from "../ApiConstants";
import { PUT } from "../method";

export const createContactUsForm = async (data) => {
  const url = ENDPOINTS.CREATE_CONTACT_US
  return PUT(url, data);
}